var exports = {
  "JC": "UserProfilePopout.module__role___Sjh4ck",
  "s$": "UserProfilePopout.module__roleRemoveIcon___Sjh4ck",
  "Bx": "UserProfilePopout.module__iconSmall___Sjh4ck",
  "bc": "UserProfilePopout.module__profileCustomStatus___Sjh4ck",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___Sjh4ck",
  "ZB": "UserProfilePopout.module__profileDisplayName___Sjh4ck",
  "yn": "UserProfilePopout.module__profileDataWarning___Sjh4ck",
  "zF": "UserProfilePopout.module__profilePopoutCard___Sjh4ck",
};

module.exports = exports;
